<template>
    <div id="contact">
        <div class="img">
            <Banner v-if="imgs.length>0" :banner="imgs" />
        </div>
        <div class="box">
            <div class="left">
                <iframe width='610' height='418' frameborder='0' scrolling='no' marginheight='0' marginwidth='0' src='https://m.amap.com/navi/?dest=114.369334,30.620052&destName=颐思特（武汉）生物科技股份有限公司&hideRouteIcon=1&key=6a23eb896c4513c6a1491cbd03e455d6'></iframe>
            </div>
            <div class="right">
                <p><span class="title">联系我们</span></p>
                <p class="txt" v-for="item in data" :key="item.id">{{item.title}}：{{item.subtitle}}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from "../components/public/Banner";
    export default {
        name: "Contact",
        components:{Banner},
        data(){
            return{
                imgs:[],
                data:[]
            }
        },
        methods:{
            //获取轮播图
            getNav(){
                this.$axios({
                    url:'/navigation/navigationbar',
                    method:'get'
                }).then(res=>{
                    if (res.data.code === 200){
                        this.imgs = res.data.msg.navigationBars[5].navigationImgs;
                    }
                })
            },
            getData(){
                this.$axios({
                    url:'/moudle/moudlemaster',
                    method:'get',
                    params:{
                        moudleType:'12'
                    }
                }).then(res=>{
                  
                    if (res.data.code === 200){
                        this.data = res.data.msg[0].moudleSlaves;
                    }
                })
            }
        },
        created() {
            this.getNav();
            this.getData();
        }
    }
</script>

<style scoped lang="less">
#contact{
    .img{
        img{
            width: 100%;
            vertical-align: bottom;
        }
    }
    .box{
        width: 1180px;
        margin: 30px auto;
        display: flex;
        .left{
            margin-right: 30px;
        }
        .right{
            .title{
                color: #181818;
                font-size: 26px;
                font-weight: bold;
                &::after{
                    content: '/ CONTACT US';
                    display: inline-block;
                    margin-left: 10px;
                    color: #999999;
                    font-size: 14px;
                    vertical-align: text-bottom;
                }
            }
            .txt{
                color: #181818;
                font-size: 14px;
                margin-top: 20px;
                &:first-child{
                    margin-top: 30px;
                }
            }
        }
    }
}
</style>
